import React, { useState, useRef, useEffect } from 'react';
import './ColorDropdown.scss';

interface ColorOption {
  value: string;
}

interface ColorDropdownProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: ColorOption[];
}

const ColorDropdown: React.FC<ColorDropdownProps> = ({ label, value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue: string) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='setting-item' ref={dropdownRef}>
      <label className='setting-label'>{label}</label>
      <div className='setting-control'>
        <div className={`color-dropdown-select ${isOpen ? 'active' : ''}`} onClick={handleToggle}>
          <div className='color-preview' style={{ backgroundColor: value }}></div>
          {/* <div className='dropdown-arrow'></div> */}
          <span className={`fas fa-caret-down pl-[2px] w-[17px] h-[17px]`} />
        </div>

        {isOpen && (
          <div className='color-dropdown-options'>
            {options.map((option) => (
              <div
                key={option.value}
                className={`color-option ${value === option.value ? 'selected' : ''}`}
                onClick={() => handleOptionClick(option.value)}
              >
                <div className='color-swatch' style={{ backgroundColor: option.value }}></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorDropdown;
